module.exports = __webpack_public_path__ + "static/media/sharechat-1.41d3e071.webp";